// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var JsxRuntime = require("react/jsx-runtime");
var SelectBoxNew$ReactHooksTemplate = require("../common/SelectBoxNew.res.js");
var CheckboxInput$ReactHooksTemplate = require("../common/CheckboxInput.res.js");
var PaginationPolicies$ReactHooksTemplate = require("./paginationPolicies.res.js");

function PaginationPolicyModes(props) {
  var onChange = props.onChange;
  var enforced = props.enforced;
  var enforce = props.enforce;
  var setting = props.setting;
  var valueToDisplay = function (value) {
    switch (value) {
      case "single_page_survey" :
          return "Single page survey";
      default:
        return "Multiple page survey";
    }
  };
  var handlePolicyChange = function ($$event) {
    var displayText = $$event.target.value;
    var value = PaginationPolicies$ReactHooksTemplate.displayToValue(displayText);
    var newPolicy = PaginationPolicies$ReactHooksTemplate.stringToPolicy(value);
    var updatedSettings = PaginationPolicies$ReactHooksTemplate.setValue(setting, newPolicy);
    Curry._2(onChange, {
          TAG: "PaginationPolicies",
          _0: updatedSettings
        }, enforce);
  };
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsx("h2", {
                                                children: "Pagination Policy Modes",
                                                className: "text-lg font-bold text-gray-900"
                                              }),
                                          className: "flex items-center space-x-2 mb-1"
                                        }),
                                    className: "flex-1"
                                  }),
                              JsxRuntime.jsx("div", {
                                    children: enforced ? null : JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                                                    checked: enforce,
                                                    disabled: enforced,
                                                    label: "Enforce Policy",
                                                    handleChange: (function (param) {
                                                        Curry._2(onChange, {
                                                              TAG: "PaginationPolicies",
                                                              _0: setting
                                                            }, !enforce);
                                                      }),
                                                    checkboxClassName: "custom_checkbox"
                                                  }),
                                              JsxRuntime.jsx("span", {
                                                    children: "🔒",
                                                    className: "text-xs font-medium text-blue-700"
                                                  })
                                            ],
                                            className: "flex items-center space-x-2 px-4 py-2 rounded-lg " + (
                                              enforce ? "bg-blue-100 border border-blue-200" : "bg-white border border-gray-200"
                                            )
                                          }),
                                    className: "ml-4"
                                  })
                            ],
                            className: "flex items-center justify-between"
                          }),
                      className: "bg-gradient-to-r from-green-50 to-emerald-50 px-6 py-4 border-b border-gray-200"
                    }),
                JsxRuntime.jsx("div", {
                      children: enforced ? JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("label", {
                                              children: "Pagination Mode",
                                              className: "text-sm font-medium text-gray-600 block mb-1"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: valueToDisplay(PaginationPolicies$ReactHooksTemplate.policyToString(PaginationPolicies$ReactHooksTemplate.value(setting))),
                                              className: "text-base font-semibold text-gray-900"
                                            })
                                      ],
                                      className: "flex-1"
                                    }),
                                JsxRuntime.jsx("span", {
                                      children: "Enforced",
                                      className: "text-xs font-medium text-blue-700 bg-blue-100 px-3 py-1 rounded-full"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx("span", {
                                            children: "🔒",
                                            className: "text-blue-600 text-sm"
                                          }),
                                      className: "flex-shrink-0 w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center"
                                    })
                              ],
                              className: "flex items-center space-x-4 p-4 bg-gray-50 rounded-lg border border-verdigris"
                            }) : JsxRuntime.jsx(SelectBoxNew$ReactHooksTemplate.make, {
                              label: "Pagination Mode",
                              value: valueToDisplay(PaginationPolicies$ReactHooksTemplate.policyToString(PaginationPolicies$ReactHooksTemplate.value(setting))),
                              handleChange: handlePolicyChange,
                              labelCSS: "text-base font-medium ml-5",
                              options: {
                                hd: "Single page survey",
                                tl: {
                                  hd: "Multiple page survey",
                                  tl: /* [] */0
                                }
                              }
                            }),
                      className: "p-6"
                    })
              ]
            });
}

var make = PaginationPolicyModes;

exports.make = make;
/* react/jsx-runtime Not a pure module */
